import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function PhoneSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.phone')}
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="76"
      viewBox="0 0 59 76"
      className={clsx(styles.brand, className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.9762 26.0253H34.5244V22.0928H46.9762V26.0253Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.6911 19.4124H34.5244V15.4789H52.6911V19.4124Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.0475 32.6022H35.4575L29.168 39.0486V8.90307H58.0475V32.6022ZM30.0363 36.9143L30.0374 36.9122V9.77143L30.0363 36.9143ZM34.1788 29.5369L32.1802 31.5631V31.5652L34.1788 29.5369ZM33.0475 29.4468L33.8162 28.6686H54.168V12.8367H33.0475V29.4468Z"
        fill="inherit"
      />
      <path d="M30.3438 66.3261H16.7035V63.1241H30.3438V66.3261Z" fill="inherit" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.0473 10.8571H41.589V9.95273H41.6187V5.42857H5.42857V9.77143H5.41797V16.2857H5.42857V53.4502H41.6187V30.4H47.0473V76H0V0H47.0473V10.8571ZM5.42857 70.5714H41.6187V58.8788H5.42857V70.5714Z"
        fill="inherit"
      />
    </svg>
  );
}
